import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as remixActions from './actions/remix-actions';
import AudioPlayer from './AudioPlayer';
import NowPlaying from './NowPlaying';

class SamPlayer extends Component {

  componentDidMount(){
    this.props.remixActions.getStreamUrl();
  }

  render(){
    return (
      <div className="Player Remix">
        <NowPlaying currentTrack={ this.props.currentTrack } />
        <AudioPlayer 
          stream_url={ this.props.currentTrack.stream_url } 
          remix={ this.props.player.remix } />
        <div className="clearfix"></div>
      </div>
    );
  }
}

function mapStateToProps(state, props){
  return {
    player: state.app.player.toJS(),
    currentTrack: state.app.currentTrack.toJS()
  }
}

function mapDispatchToProps(dispatch){
  return {
    remixActions: bindActionCreators(remixActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SamPlayer);



// WEBPACK FOOTER //
// ./src/RemixPlayer.js